import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Button, CardText, Spinner, } from 'reactstrap';
import { APP_VERSION, getTenantByKey, getUserDataByKey, isUnique, toLibraryLanguage } from '../../helpers/helpers';
import { ForgotPassword } from '../../components/ForgotPassword/ForgotPassword';
import { useTranslation } from 'react-i18next';
import TenantContext from '../../context/Tenant/TenantContext';
import LoginContext from '../../context/Login/LoginContext';
import { exactianLogoWord } from '../../assets/icons';
import backgroundImgLogin from '../../assets/images/photo-login.png';
import PasswordInput from '../../components/Inputs/PasswordInput';
import { CustomAlert } from '../../components/CustomAlert/CustomAlert';
import { ExactianLoader } from '../../components/ExactianLoader/ExactianLoader';
import orangeArrow from '../../assets/images/orange-arrows.png';
import { ErrorScreen } from '@exactian/exactian-components';

export const Login = () => {

  const { loginSession, loginState } = useContext(LoginContext)

  const { getTenant, tenant } = useContext(TenantContext)

  const initialState = {
    user_name: '',
    password: '',
  }

  const { t } = useTranslation();

  const [userInfo, setUserInfo] = useState(initialState);

  const [modal, setModal] = useState(false);

  const disabled = !!!userInfo.user_name.trim() || !!!userInfo.password.trim();

  const handleChange = (e) => {
    setUserInfo({
      ...userInfo,
      [e.target.name]: e.target.value,
    });
  };
  const handleLogin = () => {
    loginSession(userInfo);
  }

  /*   const minHeight = {
      minHeight: '100vh',
    }; */

  const onKeyPress = (e) => {
    if ((e.key === 'Enter') & !disabled) {
      handleLogin();
    }
  };

  const clientLogo = getTenantByKey('logo');

  const appName = getTenantByKey('app_name');

  useEffect(() => {
    getTenant();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (tenant.isFetching === true || loginState.isFetching === true) {
    return (
      <div className='d-flex flex-column min-vh-100' style={{ overflowX: 'hidden' }}>
        <div className="row justify-content-center flex-grow-1">
          <div className='col-xl-4 col-lg-7 col-sm-9 mt-3'>
            <div className='d-flex justify-content-center align-items-center h-100'>
              <ExactianLoader />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (tenant.error) {
    return (
      <ErrorScreen
        language={toLibraryLanguage(getUserDataByKey('lang') || 'es')}
        message={t('common.error_tenant')}
      />
    )
  }

  return (
    <div className='d-flex flex-column min-vh-100' style={{ overflowX: 'hidden' }}>
      <div className="row justify-content-center flex-grow-1">
        <div className='col-xl-4 col-lg-7 col-sm-9 mt-3'>
          <div className='' style={{ backgroundColor: 'var(--white)' }}>

            <ForgotPassword modal={modal} setModal={setModal} />

            <div className="login-banner position-relative">
              <img
                src={backgroundImgLogin}
                className=""
                alt="fondo-exactian-login"
                style={{ width: '100%', height: '100%' }}
              />

              <div className="logo-container">
                <img src={exactianLogoWord} alt="ExactianLogo" className="exactian-logo" />
              </div>

              <div className="arrow-container d-flex align-items-center gap-2">
                <img src={orangeArrow}
                  alt="orange-arrow"
                  className="exactian-logo"
                  style={{ width: '50px', height: '50px' }}
                />
                {
                  tenant.isFetching && !tenant.error ?
                    <Spinner className='mx-auto d-flex' size={'XXL'} />
                    :
                    tenant.error ?
                      <h3 className='white-color'>
                        Exactian - Inducciones
                      </h3>
                      :
                      <h3 className="white-color">
                        {appName}
                      </h3>

                }

              </div>
            </div>

            <div className='p-3'>

              <div className='d-flex justify-content-center'>

                {
                  tenant.isFetching && !tenant.error ?
                    <Spinner className='mx-auto d-flex' size={'XXL'} />
                    :
                    tenant.error ?
                      <CustomAlert text={t('common.error_tenant')} color={'danger'} />
                      :
                      <>
                        <img
                          src={clientLogo}
                          className="img-fluid"
                          alt="exactian-logo"
                          style={{ width: '20%' }}
                        />
                      </>
                }
              </div>

              <form onSubmit={handleLogin}>
                {loginState.error ? <CustomAlert text={loginState.message} color={'danger'} /> : null}
                <div>
                  <label
                    htmlFor="user_name"
                    className="form-label gray-color-500"
                  >
                    {t('login.user_name')}
                  </label>
                  <input
                    placeholder={t('login.user_name')}
                    type="text"
                    name="user_name"
                    className="form-control"
                    autoComplete='off'
                    onChange={(e) => handleChange(e)}
                    value={userInfo.user_name}
                  />
                </div>
                <div className='mt-4'>
                  <label
                    htmlFor="password"
                    className="form-label gray-color-500"
                  >
                    {t('login.password')}
                  </label>
                  <PasswordInput
                    name={"password"}
                    placeholder={t('login.password')}
                    onChange={(e) => handleChange(e)}
                    value={userInfo.password}
                    onKeyPress={onKeyPress}
                  />
                </div>

                {
                  isUnique() ?
                    <div
                      className='mt-3 d-flex justify-content-end'
                      style={{ cursor: 'pointer' }}
                      onClick={() => setModal(true)}
                    >
                      {t('login.forgotPassword')}
                    </div>
                    :
                    null
                }

                {
                  tenant.isFetching ?
                    <div className="d-flex mt-4 justify-content-center">
                      <Spinner />
                    </div>
                    :
                    <>
                      <Button
                        style={{ backgroundColor: '#e73f14', color: '#fff', border: 'none' }}
                        className={`btn w-100 mt-4`}
                        disabled={disabled}
                        onClick={handleLogin}
                      >
                        <span>{t('login.login')}</span>
                      </Button>
                    </>
                }
              </form>
              {
                tenant.isFetching && !tenant.error ?
                  <Spinner size={'XXL'} className='d-flex mx-auto' />
                  :
                  <CardText className="text-muted text-center mt-4">
                    <small>
                      V. {APP_VERSION} - © - Exactian Consulting S.A. -{' '}
                      <a
                        href="https://www.exactian.com"
                        className="card-link text-primary"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        www.exactian.com
                      </a>
                    </small>
                  </CardText>
              }
            </div>
          </div >
        </div>
      </div>
    </div>
  )
}
